import { useState } from 'react'

const BREAKPOINT = 420

export default function() {
  const isSmall = document.documentElement.clientWidth <= BREAKPOINT
  return { isSmall }
}
